
export const types = {
  SET_ACCOUNT_WITH_RISK: 'UINEEDS/SET_ACCOUNT_WITH_RISK',
  SET_CLIENT_WITH_RISK: 'UINEEDS/SET_CLIENT_WITH_RISK',
  SEND_RISK_TO_GENESYS: 'UINEEDS/SEND_RISK_TO_GENESYS',
  SEND_RISK_TO_GENESYS_SUCCESS: 'UINEEDS/SEND_RISK_TO_GENESYS_SUCCESS',
  SET_RISK_EVALUATION_REQUIREMENTS: 'UINEEDS/SET_RISK_EVALUATION_REQUIREMENTS',
  SET_CLIENT_RISK_DETAILS: 'UINEEDS/SET_CLIENT_RISK_DETAILS',
};

export const initialState = {
  accountWithRisk: false,
  clientWithRisk: false,
  riskEvaluationRequirements: null,
  sendingRiskToSE: false,
  sendRiskToGenesysSuccess: false,
  clientWithoutAvailableCredit: false,
  clientWithDebt: false,
  clientWithUnknownRisk: false,
};

const UINeedsRiskReducer = (state, action) => {
  switch (action.type) {
    case types.SET_RISK_EVALUATION_REQUIREMENTS: {
      const { riskEvaluationRequirements } = action.payload;

      const newState = {
        ...state,
        riskEvaluationRequirements,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SEND_RISK_TO_GENESYS: {
      const { sendingRiskToSE } = action.payload;

      const newState = {
        ...state,
        sendingRiskToSE,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SEND_RISK_TO_GENESYS_SUCCESS: {
      const { sendRiskToGenesysSuccess } = action.payload;

      const newState = {
        ...state,
        sendRiskToGenesysSuccess,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SET_ACCOUNT_WITH_RISK: {
      const { riskError } = action.payload;
      const newState = {
        ...state,
        accountWithRisk: true,
        riskError,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SET_CLIENT_WITH_RISK: {
      const { riskError } = action.payload;

      const newState = {
        ...state,
        clientWithRisk: true,
        riskError,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SET_CLIENT_RISK_DETAILS: {
      const { riskDetails } = action.payload;
      const { clientWithoutAvailableCredit, clientWithDebt, clientWithUnknownRisk, riskCode, monthlyCreditLimit, creditLimit } = riskDetails;
      const newState = {
        ...state,
        clientWithoutAvailableCredit,
        clientWithDebt,
        clientWithUnknownRisk,
        riskCode,
        monthlyCreditLimit,
        creditLimit
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setAccountWithRisk: (riskError) => ({
    type: types.SET_ACCOUNT_WITH_RISK,
    payload: {
      riskError,
    },
  }),
  setClientWithRisk: (riskError) => ({
    type: types.SET_CLIENT_WITH_RISK,
    payload: {
      riskError,
    },
  }),
  sendRiskToGenesys: (error) => ({
    type: types.SEND_RISK_TO_GENESYS,
    payload: {
      sendingRiskToSE: true,
      error,
    },
  }),
  sendRiskToGenesysSuccess: () => ({
    type: types.SEND_RISK_TO_GENESYS_SUCCESS,
    payload: {
      sendRiskToGenesysSuccess: true,
    },
  }),
  setRiskEvaluationRequirements: riskEvaluationRequirements => ({
    type: types.SET_RISK_EVALUATION_REQUIREMENTS,
    payload: {
      riskEvaluationRequirements,
    },
  }),
  setClientRiskDetails: (riskDetails) => ({
    type: types.SET_CLIENT_RISK_DETAILS,
    payload: {
      riskDetails,
    },
  }),
};

export default UINeedsRiskReducer;
